import { ReduxDevToolsConfig, withReduxDevTools } from 'lib/hooks';

export interface Action {
  name: string;
  payload?: any;
}

export type ActionHandler<S> = (state: S, payload?: any) => S;

export interface ActionHandlers<S> {
  [x: string]: ActionHandler<S>;
}

export interface CreateReducerConfig<S, A> {
  actionHandlers: ActionHandlers<S>;
  middleware?: (state: S, action: A) => void;
  devToolsOptions?: ReduxDevToolsConfig<S>;
}

export const createReducer = <S, A extends Action>({
  actionHandlers,
  middleware,
  devToolsOptions
}: CreateReducerConfig<S, A>) => {
  const devTools = devToolsOptions ? withReduxDevTools(devToolsOptions) : undefined;

  return (state: S, action: A) => {
    const actionHandler = actionHandlers[action.name];

    if (!actionHandler) throw new Error(`Unhandled action type: ${action.name}`);

    if (middleware) middleware(state, action);

    const newState = actionHandler(state, action.payload);

    if (devTools) devTools.send(action.name, newState);

    return newState;
  };
};
